import React from "react"

export default () => (
    <div className="circleC">
        <svg xmlns="http://www.w3.org/2000/svg" width="419" height="419"><path className="circleCsvg" d="M209.5,0C325.2,0,419,93.8,419,209.5S325.2,419,209.5,419,0,325.2,0,209.5C0,141.93,31.989,81.831,81.956,43.286A208.317,208.317,0,0,1,209.5,0Z"/></svg>
    </div>
)